import { WecdevError, INotificationService, WecdevErrorType, WebCoreIoCKeys, IoCContainer, IWebCoreIoCContainer } from 'web-core-src';
import { Diagnostic } from '../error-handling/diagnostic.class';

export abstract class ServiceBase {
    private notificationService: INotificationService;
    private coreIoc: IWebCoreIoCContainer;

    constructor() {
        this.coreIoc = IoCContainer.get(WebCoreIoCKeys.IWebCoreIoCContainer);
        this.notificationService = this.coreIoc.notificationService;
    }

    private getHandlerServerErrorPromise<T>(): Promise<T> {
        return Promise.reject<T>(new WecdevError(WecdevErrorType.SERVER_ERROR, WecdevError.ERROR_HANDLED));
    }

    private getHandlerAuthenticationErrorPromise<T>(): Promise<T> {
        return Promise.reject<T>(new WecdevError(WecdevErrorType.AUTHENTICATION_ERROR, WecdevError.ERROR_HANDLED));
    }

    private getHandlerAuthorizationErrorPromise<T>(): Promise<T> {
        return Promise.reject<T>(new WecdevError(WecdevErrorType.AUTHORIZATION_ERROR, WecdevError.ERROR_HANDLED));
    }

    protected handleResult<T>(res: Promise<T>): Promise<T> {
        return res.then(
            (response: any): Promise<T> => {
                return response;
            },
            (errorResponse: any): Promise<T> => {
                if (errorResponse instanceof ErrorEvent) {
                    // A client-side or network error occurred.
                    Diagnostic.handleError(errorResponse);
                    return this.getHandlerServerErrorPromise();
                } else {
                    //WecdevError
                    let errorTypes: string[] = [WecdevErrorType.SERVER_ERROR, WecdevErrorType.AUTHORIZATION_ERROR, WecdevErrorType.AUTHENTICATION_ERROR, WecdevErrorType.VALIDATION_ERROR];
                    let wecdevError: WecdevError = null;
                    if (errorResponse.responseJSON) {
                        wecdevError = errorResponse.responseJSON;
                        //wecdevError = JSON.parse(errorResponse.responseJSON);
                    }
                    if ((errorResponse.status === 500 || errorResponse.status === 401 || errorResponse.status === 400) && wecdevError != null && errorTypes.includes(wecdevError.type)) {
                        //SERVER_ERROR
                        if (errorResponse.status === 500) {
                            this.notificationService.createTimedDangerTranslateMessage(wecdevError.message);
                            return this.getHandlerServerErrorPromise();
                            //AUTHORIZATION_ERROR or AUTHENTICATION_ERROR
                        } else if (errorResponse.status === 401) {
                            this.notificationService.createTimedDangerTranslateMessage(wecdevError.message);
                            if (wecdevError.type == WecdevErrorType.AUTHENTICATION_ERROR) {
                                return this.getHandlerAuthenticationErrorPromise();
                            } else if (wecdevError.type == WecdevErrorType.AUTHORIZATION_ERROR) {
                                return this.getHandlerAuthorizationErrorPromise();
                            }
                            throw new Error('Not handled WecdevErrorType and httpstatus: ');
                            //VALIDATION_ERROR
                        } else if (errorResponse.status === 400) {
                            return Promise.reject<T>(wecdevError);
                        } else {
                            throw new Error('Not handled WecdevErrorType and httpstatus: ');
                        }
                    } else {
                        Diagnostic.handleError(errorResponse);
                        return this.getHandlerServerErrorPromise();
                    }
                }
            }
        );
    }
}
